'use strict';

var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _require = require('peer-id'),
    createFromPrivKey = _require.createFromPrivKey;

var series = require('async/series');

var Receptacle = require('receptacle');

var debug = require('debug');

var log = debug('jsipfs:ipns');
log.error = debug('jsipfs:ipns:error');

var IpnsPublisher = require('./publisher');

var IpnsRepublisher = require('./republisher');

var IpnsResolver = require('./resolver');

var path = require('./path');

var defaultRecordTtl = 60 * 1000;

var IPNS =
/*#__PURE__*/
function () {
  function IPNS(routing, ipfs) {
    _classCallCheck(this, IPNS);

    this.publisher = new IpnsPublisher(routing, ipfs._repo);
    this.republisher = new IpnsRepublisher(this.publisher, ipfs);
    this.resolver = new IpnsResolver(routing, ipfs._repo);
    this.cache = new Receptacle({
      max: 1000
    }); // Create an LRU cache with max 1000 items
  } // Publish


  _createClass(IPNS, [{
    key: "publish",
    value: function publish(privKey, value, lifetime, callback) {
      var _this = this;

      series([function (cb) {
        return createFromPrivKey(privKey.bytes, cb);
      }, function (cb) {
        return _this.publisher.publishWithEOL(privKey, value, lifetime, cb);
      }], function (err, results) {
        if (err) {
          log.error(err);
          return callback(err);
        }

        log("IPNS value ".concat(value, " was published correctly")); // Add to cache

        var id = results[0].toB58String();
        var ttEol = parseFloat(lifetime);
        var ttl = ttEol < defaultRecordTtl ? ttEol : defaultRecordTtl;

        _this.cache.set(id, value, {
          ttl: ttl
        });

        log("IPNS value ".concat(value, " was cached correctly"));
        callback(null, {
          name: id,
          value: value
        });
      });
    } // Resolve

  }, {
    key: "resolve",
    value: function resolve(name, peerId, options, callback) {
      // If recursive, we should not try to get the cached value
      if (!options.nocache && !options.recursive) {
        // Try to get the record from cache
        var id = name.split('/')[2];
        var result = this.cache.get(id);

        if (result) {
          return callback(null, {
            path: result
          });
        }
      }

      this.resolver.resolve(name, peerId, options, function (err, result) {
        if (err) {
          log.error(err);
          return callback(err);
        }

        log("IPNS record from ".concat(name, " was resolved correctly"));
        callback(null, {
          path: result
        });
      });
    } // Initialize keyspace
    // sets the ipns record for the given key to point to an empty directory

  }, {
    key: "initializeKeyspace",
    value: function initializeKeyspace(privKey, value, callback) {
      this.publisher.publish(privKey, value, callback);
    }
  }]);

  return IPNS;
}();

exports = module.exports = IPNS;
exports.path = path;